<template>
  <div id="documentDeveloperContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <!-- <img class="icon-pages" src="../assets/images/ic_happily-village-32px.png" /> -->
        <span class="page-title">Documentation</span>
        <span class="page-des ml-16">If your code doesn't work. lets change noting and run it again.</span>
      </div>
       <el-tabs class="style-bar" v-model="activeName" @tab-click="forceRerender">
        <el-tab-pane name="#icons">
          <span slot="label" class="title-bar">Icons</span>
          <icons></icons>
        </el-tab-pane>
        <!-- <el-tab-pane name="coaching">
          <span slot="label" class="title-bar">Coaching</span>
          <coaching></coaching>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "document-developer",
  components: {
    icons: require("./document-developer/icons").default,
  },
  data() {
    return {
      activeName: "#icons",
      anchor: {
        icons: "#icons",
      },
    };
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        this.$router.push({ hash: this.activeName });
      }
    }
  },
  mounted() {
    const hash = this.$router.currentRoute.hash;
    if (hash) {
      this.activeName = this.anchor[this.$utils('removeHashURL', {
        hash: hash,
        anchor: this.anchor,
        default: "#icons"
      })];
    }
  },
  methods: {
    tabChange(tab) {
      this.activeName = tab;
    },
    forceRerender() {
      this.$router.push({ hash: this.activeName });
    }
  }
};
</script>

<style lang="scss" scoped>
.styleTab {
  margin-top: 32px;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
}
</style>
<style lang="scss">
#documentDeveloperContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#documentDeveloperContainer .el-tabs__header {
  margin: 0px;
}
</style>
